import React from "react";
import { useTheme } from "@mui/material/styles"; // or styled-components
import { AppBar, Toolbar, Typography } from "@mui/material";
import PropTypes from "prop-types";

function Header({ title = "" }) {
  const theme = useTheme();

  return (
    <AppBar position="static" style={{ backgroundColor: theme.colors.primary }}>
      <Toolbar>
        <img
          src={theme.custom.logo}
          alt="Logo"
          style={{ height: "50px", marginRight: "20px" }}
        />
        <Typography variant="h6" style={{ color: theme.colors.text }}>
          {title}
        </Typography>
        {/* Add navigation links or other elements here */}
      </Toolbar>
    </AppBar>
  );
}

// Define prop types for better type checking
Header.propTypes = {
  title: PropTypes.string.isRequired,
};

export default Header;
